// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Toast, Picker, Loading, Uploader, Collapse, CollapseItem, List, Swipe, SwipeItem, Tabbar, TabbarItem, ActionSheet, Area, Popup, Dialog, Sticky, Switch, Overlay  } from 'vant';

Vue.use(Toast);
Vue.use(Picker);
Vue.use(Loading);
Vue.use(Uploader);
Vue.use(Collapse).use(CollapseItem);
Vue.use(List);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(ActionSheet);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Sticky);
Vue.use(Switch);
Vue.use(Overlay);

import './assets/style/common.css'

Vue.config.productionTip = false
global.HOST_V = '/api/v1';
global.HOST = '/api';
global.HOST_R = '/rep';

let u = navigator.userAgent;
global.android = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
global.iOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
global.weixin = u.toLowerCase().indexOf('micromessenger') > -1; //小程序

// 获取当前的协议和域名，用于拼接路由进行页面跳转
global.WEB_HOST = document.location.protocol + '//' + window.location.host;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js